//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-haut.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
export default {
  name: 'ThumbnailListArrowButton',
  props: {
    arrowDirection: {
      type: String,
      default: 'up',

      validator(value) {
        return ['up', 'down'].includes(value);
      }

    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonData() {
      var data = {
        label: 'buttonLabelUp',
        icon: 'chevron-haut'
      };

      if (this.arrowDirection === 'down') {
        data.label = 'buttonLabelDown';
        data.icon = 'chevron-bottom-doodle';
      }

      return data;
    }

  }
};